import { UtilStorage } from './utilStorage';
export class UtilLocalStorage extends UtilStorage {
    /**
     * @inheritDoc
     */
    static set(key, value, ttl = 86400000) {
        super.set(key, value, ttl, localStorage);
    }
    /**
     * @inheritDoc
     */
    static get(key) {
        return super.get(key, localStorage);
    }
    /**
     * @inheritDoc
     */
    static delete(key) {
        super.delete(key, localStorage);
    }
    /**
     * @inheritDoc
     */
    static isSet(key) {
        return super.isSet(key, localStorage);
    }
}
